import React, { useEffect } from "react";
import { useLocalization } from "../../context/LocalizationContext";
import { getPlatformInfo } from "../../utils/helpers";
import balsameeIcon from "../../assets/images/balsameeIcon.svg";
import "./styles.css";

const RedirectPage: React.FC = () => {
  const { t } = useLocalization();

  useEffect(() => {
    const { isAndroid, deepLink, storeUrl, androidIntent } = getPlatformInfo();
    
    if (isAndroid && androidIntent) {
      // Android: use intent:// URL — works reliably in Chrome Custom Tabs
      // and includes automatic store fallback
      window.location.href = androidIntent;
    } 
    // Fallback timer: if the app doesn't open within 3s, redirect to store
    const timer = setTimeout(() => {
      if (storeUrl) {
        window.location.href = storeUrl;
      }
    }, 1000);

    return () => clearTimeout(timer);
  }, [t]);

  return (
    <div className="app-redirect">
        <img src={balsameeIcon} alt="Balsamee" className="redirect-logo" />
    </div>
  );
};

export default RedirectPage;
